<template>
<div class="chapter">
<div class="inner_page">
<div class="title">
<h2 class="titlePageAuthor" id="tp"><span class="bold">ARI FLEISCHER</span></h2>
<h2 class="titlePageTitle"><span class="bold">TAKING</span></h2>
<hr/>
<p class="titlePageText"><em class="italic">The President, the Press, and<br/>
My Years in the White House</em></p>
<hr/>
<h2 class="titlePageTitle"><span class="bold">HEAT</span></h2>
<br/>
<br/>
<br/>
<br/>
<p style="text-align:center;"><img alt="" src="logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780061755149_title.vue?ddcaf622